import React from 'react';
import Link from 'next/link';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import styles from '../../styles/blog/articleNavigation.module.scss';

export default function ArticleNavigation({ prev, next }) {
    if (!prev && !next) return null;

    return (
        <nav className={styles.navigation}>
            <div className={styles.navInner}>
                {prev ? (
                    <Link href={`/blog/${prev.slug}`} className={styles.navLink}>
                        <ArrowLeft size={20} />
                        <div className={styles.navText}>
                            <span className={styles.navLabel}>Previous</span>
                            <span className={styles.navTitle}>{prev.title}</span>
                        </div>
                    </Link>
                ) : (
                    <div />
                )}
                {next ? (
                    <Link href={`/blog/${next.slug}`} className={`${styles.navLink} ${styles.navRight}`}>
                        <div className={styles.navText}>
                            <span className={styles.navLabel}>Next</span>
                            <span className={styles.navTitle}>{next.title}</span>
                        </div>
                        <ArrowRight size={20} />
                    </Link>
                ) : (
                    <div />
                )}
            </div>
        </nav>
    );
}
